"use client";

import {ManageBookingItem} from "@/types/booking";
import {AiOutlineFileSearch} from "react-icons/ai";
import {Card} from "./card";

const upComingDummyCards: ManageBookingItem[] = [
  {
    name: "Demo User 1",
    image: "/images/avatar.png",
    bookingId: 3001,
    vehicleName: "TN01AB1234",
    bookingTime: new Date("2026-06-01T09:00:00").getTime(),
    driverName: "Kumar Driver",
    driverEmpId: "SAMP070",
    pickupPoint: "Gandhipuram",
    dropPoint: "NeoSay Campus"
  },
  {
    name: "Demo User 2",
    image: "/images/avatar.png",
    bookingId: 3002,
    vehicleName: "TN38XY5678",
    bookingTime: new Date("2026-06-01T10:30:00").getTime(),
    driverName: "Ravi Driver",
    driverEmpId: "SAMP071",
    pickupPoint: "Peelamedu",
    dropPoint: "Airport"
  }
];
export const UpComing = ({
  filterData
}: {
  filterData: ManageBookingItem[] | null;
}) => {
  const cardsToRender =
    filterData && filterData.length > 0 ? filterData : upComingDummyCards;
  return (
    <>
      <div className="grid grid-cols-4 gap-3 p-3">
        {cardsToRender.map((b: ManageBookingItem) => (
          <Card key={b.bookingId} b={b} statusType={2} />
        ))}
        {!filterData && (
          <div className="col-span-full flex min-h-[260px] w-full flex-col items-center justify-center text-center">
            {/* Icon */}
            <div className="mb-4">
              <AiOutlineFileSearch size={48} className="" />
            </div>

            {/* Title */}
            <h2 className="text-lg font-semibold text-gray-800">
              No record found
            </h2>

            {/* Description */}
            <p className="mt-1 text-sm text-gray-500">
              Please adjust the name of your search, or there is no data
              available.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
